import { IntegrationType } from './types';

const buildMenuItems = (integration: IntegrationType, isAdmin: boolean) => {
  const isDisabled =
    !isAdmin ||
    integration.isPublic ||
    integration.isBeta ||
    integration.isPending;

  const editActionItem = { label: 'Edit', value: 'edit' };
  const deleteActionItem = {
    label: 'Delete',
    value: 'delete',
    isDisabled,
    shouldConfirm: !isDisabled,
  };
  return [editActionItem, deleteActionItem];
};

export { buildMenuItems };
